export const Graphics = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
            <path
                d="M7 4C6.0111 4 5.0444 4.29324 4.22215 4.84265C3.39991 5.39206 2.75904 6.17295 2.3806 7.08658C2.00217 8.00021 1.90315 9.00555 2.09608 9.97545C2.289 10.9454 2.76521 11.8363 3.46447 12.5355C4.16373 13.2348 5.05465 13.711 6.02455 13.9039C6.99446 14.0969 7.99979 13.9978 8.91342 13.6194C9.82705 13.241 10.6079 12.6001 11.1574 11.7779C11.7068 10.9556 12 9.98891 12 9H7V4Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9 7H14C14 5.67392 13.4732 4.40215 12.5355 3.46447C11.5979 2.52678 10.3261 2 9 2V7Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const Key = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
            <path
                d="M10.3077 3.84615C11.3273 3.84615 12.1538 4.67271 12.1538 5.69231M14 5.69231C14 7.73151 12.3469 9.38462 10.3077 9.38462C10.0918 9.38462 9.88033 9.3661 9.67464 9.33056C9.32817 9.27069 8.96124 9.34645 8.71262 9.59507L7.07692 11.2308H5.69231V12.6154H4.30769V14H2V12.2658C2 11.8986 2.14588 11.5464 2.40554 11.2868L6.40493 7.28738C6.65355 7.03876 6.72931 6.67183 6.66944 6.32536C6.63391 6.11967 6.61538 5.90815 6.61538 5.69231C6.61538 3.6531 8.26849 2 10.3077 2C12.3469 2 14 3.6531 14 5.69231Z"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const Bulb = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
            <path
                d="M8.28571 12.4286V9.42857M8.28571 9.42857C8.58168 9.42857 8.8689 9.3911 9.14286 9.32059M8.28571 9.42857C7.98974 9.42857 7.70253 9.3911 7.42857 9.32059M9.57143 13.594C9.15496 13.673 8.72517 13.7143 8.28572 13.7143C7.84626 13.7143 7.41647 13.673 7 13.594M9.14286 14.9554C8.86117 14.9849 8.5752 15 8.28571 15C7.99622 15 7.71026 14.9849 7.42857 14.9554M9.57143 12.4286V12.319C9.57143 11.7574 9.94758 11.2772 10.4334 10.9953C11.7117 10.2536 12.5714 8.87004 12.5714 7.28571C12.5714 4.91878 10.6526 3 8.28571 3C5.91878 3 4 4.91878 4 7.28571C4 8.87004 4.85969 10.2536 6.13803 10.9953C6.62384 11.2772 7 11.7574 7 12.319V12.4286"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const CmsIcon = () => {
    return (
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.92431 3.99219L1.91737 7.99913C1.64075 8.27575 1.64075 8.72425 1.91737 9.00087L6.42518 13.5087C6.7018 13.7853 7.15029 13.7853 7.42691 13.5087L11.4339 9.50173C11.7105 9.22511 11.7105 8.77662 11.4339 8.5L6.92604 3.99219C6.64942 3.71557 6.20093 3.71557 5.92431 3.99219Z" stroke="white" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.1743 3.99219L6.16737 7.99913C5.89075 8.27575 5.89075 8.72425 6.16737 9.00087L10.1743 13.0078C10.4509 13.2844 10.8994 13.2844 11.176 13.0078L15.183 9.00087C15.4596 8.72425 15.4596 8.27575 15.183 7.99913L11.176 3.99219C10.8994 3.71557 10.4509 3.71557 10.1743 3.99219Z" stroke="white" strokeWidth="1.41667" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    );
};

export const Warning = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 6V8.5M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM8 10.5H8.005V10.505H8V10.5Z"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const Computer = ({ color = "white", strokeWidth = "1.5" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16" fill="none">
            <path
                d="M7 12.5V13.1713C7.00003 13.4341 6.9483 13.6942 6.84775 13.937C6.7472 14.1797 6.59981 14.4002 6.414 14.586L6 15H12L11.586 14.586C11.4002 14.4002 11.2528 14.1797 11.1523 13.937C11.0517 13.6942 11 13.4341 11 13.1713V12.5M15 4.5V11C15 11.3978 14.842 11.7794 14.5607 12.0607C14.2794 12.342 13.8978 12.5 13.5 12.5H4.5C4.10218 12.5 3.72064 12.342 3.43934 12.0607C3.15804 11.7794 3 11.3978 3 11V4.5M15 4.5C15 4.10218 14.842 3.72064 14.5607 3.43934C14.2794 3.15804 13.8978 3 13.5 3H4.5C4.10218 3 3.72064 3.15804 3.43934 3.43934C3.15804 3.72064 3 4.10218 3 4.5M15 4.5V9C15 9.39782 14.842 9.77936 14.5607 10.0607C14.2794 10.342 13.8978 10.5 13.5 10.5H4.5C4.10218 10.5 3.72064 10.342 3.43934 10.0607C3.15804 9.77936 3 9.39782 3 9V4.5"
                stroke={color}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const ArrowUp = ({ isOpen }) => {
    return (
        <svg
            className={`ml-auto transition-all duration-300 ${isOpen ? "-rotate-180" : ""}`}
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 12 12"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.73484 3.85983C5.88128 3.71339 6.11872 3.71339 6.26516 3.85983L10.0152 7.60984C10.1616 7.75628 10.1616 7.99372 10.0152 8.14016C9.86872 8.28661 9.63128 8.28661 9.48483 8.14016L6 4.65533L2.51517 8.14016C2.36872 8.28661 2.13128 8.28661 1.98483 8.14016C1.83839 7.99372 1.83839 7.75628 1.98483 7.60984L5.73484 3.85983Z"
                fill="white"
            />
        </svg>
    );
};
export const Clock = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 4V8H11M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const Task = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 4.02801C6.90107 3.04224 5.47626 2.49797 4 2.50001C3.29867 2.50001 2.62533 2.62001 2 2.84134V12.3413C2.64241 12.1147 3.31878 11.9993 4 12C5.53667 12 6.93867 12.578 8 13.528M8 4.02801C9.09889 3.04219 10.5237 2.4979 12 2.50001C12.7013 2.50001 13.3747 2.62001 14 2.84134V12.3413C13.3576 12.1147 12.6812 11.9993 12 12C10.5237 11.998 9.09893 12.5422 8 13.528M8 4.02801V13.528"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const ComputerPlus = ({ color = "#686868" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path
                d="M6.33333 13.6667V14.5618C6.33338 14.9121 6.26439 15.259 6.13033 15.5826C5.99627 15.9063 5.79975 16.2003 5.552 16.448L5 17H13L12.448 16.448C12.2003 16.2003 12.0037 15.9063 11.8697 15.5826C11.7356 15.259 11.6666 14.9121 11.6667 14.5618V13.6667M17 3V11.6667C17 12.1971 16.7893 12.7058 16.4142 13.0809C16.0391 13.456 15.5304 13.6667 15 13.6667H3C2.46957 13.6667 1.96086 13.456 1.58579 13.0809C1.21071 12.7058 1 12.1971 1 11.6667V3M17 3C17 2.46957 16.7893 1.96086 16.4142 1.58579C16.0391 1.21071 15.5304 1 15 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3M17 3V9C17 9.53043 16.7893 10.0391 16.4142 10.4142C16.0391 10.7893 15.5304 11 15 11H3C2.46957 11 1.96086 10.7893 1.58579 10.4142C1.21071 10.0391 1 9.53043 1 9V3M9 3.66667V9M5.88889 6.33333H12.1111"
                stroke={color}
                strokeWidth="1.2"
            />
        </svg>
    );
};

export const IconErrorHrs = () => {
    return (
        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.125 6.5C1.125 3.80761 3.30761 1.625 6 1.625C8.69239 1.625 10.875 3.80761 10.875 6.5C10.875 9.19239 8.69239 11.375 6 11.375C3.30761 11.375 1.125 9.19239 1.125 6.5ZM6 4.625C6.20711 4.625 6.375 4.79289 6.375 5V6.875C6.375 7.08211 6.20711 7.25 6 7.25C5.79289 7.25 5.625 7.08211 5.625 6.875V5C5.625 4.79289 5.79289 4.625 6 4.625ZM6 8.75C6.20711 8.75 6.375 8.58211 6.375 8.375C6.375 8.16789 6.20711 8 6 8C5.79289 8 5.625 8.16789 5.625 8.375C5.625 8.58211 5.79289 8.75 6 8.75Z"
                fill="#E4404B"
            />
        </svg>
    );
};

export const Comments = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M6 8H8.5M6 10H8.5M6 12H8.5M10.5 12.5H12C12.3978 12.5 12.7794 12.342 13.0607 12.0607C13.342 11.7794 13.5 11.3978 13.5 11V4.072C13.5 3.31533 12.9367 2.67333 12.1827 2.61067C11.9333 2.58999 11.6838 2.57221 11.434 2.55733M11.434 2.55733C11.4782 2.70072 11.5 2.84994 11.5 3C11.5 3.13261 11.4473 3.25979 11.3536 3.35355C11.2598 3.44732 11.1326 3.5 11 3.5H8C7.724 3.5 7.5 3.276 7.5 3C7.5 2.846 7.52333 2.69733 7.56667 2.55733M11.434 2.55733C11.2453 1.94533 10.6747 1.5 10 1.5H9C8.67949 1.50008 8.36743 1.60276 8.10951 1.79303C7.85158 1.98329 7.66135 2.25113 7.56667 2.55733M7.56667 2.55733C7.316 2.57267 7.06667 2.59067 6.81733 2.61067C6.06333 2.67333 5.5 3.31533 5.5 4.072V5.5M5.5 5.5H3.25C2.836 5.5 2.5 5.836 2.5 6.25V13.75C2.5 14.164 2.836 14.5 3.25 14.5H9.75C10.164 14.5 10.5 14.164 10.5 13.75V6.25C10.5 5.836 10.164 5.5 9.75 5.5H5.5ZM4.5 8H4.50533V8.00533H4.5V8ZM4.5 10H4.50533V10.0053H4.5V10ZM4.5 12H4.50533V12.0053H4.5V12Z"
                stroke="#282828"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const NotePlus = ({ color = "#686868" }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18" fill="none">
            <path
                d="M15 10.8462V8.69231C15 7.95786 14.6207 7.2535 13.9456 6.73417C13.2705 6.21483 12.3548 5.92308 11.4 5.92308H9.8C9.48174 5.92308 9.17652 5.82582 8.95147 5.65271C8.72643 5.4796 8.6 5.24482 8.6 5V3.76923C8.6 3.03479 8.22072 2.33042 7.54558 1.81109C6.87045 1.29176 5.95478 1 5 1H3M8 7.38462V14.3077M11.2 10.8462H4.8M5.4 1H2.2C1.5376 1 1 1.41354 1 1.92308V16.0769C1 16.5865 1.5376 17 2.2 17H13.8C14.4624 17 15 16.5865 15 16.0769V8.38462C15 6.42609 13.9886 4.54779 12.1882 3.1629C10.3879 1.77802 7.94608 1 5.4 1Z"
                stroke={color}
                strokeWidth="1.2"
            />
        </svg>
    );
};
export const Calendar = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M2 6H14M4.66667 2V3.33333M11.3333 2V3.33333M4 8H5.33333M7.33333 8H8.66667M10.6667 8H12M4 10H5.33333M7.33333 10H8.66667M10.6667 10H12M4 12H5.33333M7.33333 12H8.66667M10.6667 12H12M4.13333 14H11.8667C12.6134 14 12.9868 14 13.272 13.8547C13.5229 13.7269 13.7269 13.5229 13.8547 13.272C14 12.9868 14 12.6134 14 11.8667V5.46667C14 4.71993 14 4.34656 13.8547 4.06135C13.7269 3.81046 13.5229 3.60649 13.272 3.47866C12.9868 3.33333 12.6134 3.33333 11.8667 3.33333H4.13333C3.3866 3.33333 3.01323 3.33333 2.72801 3.47866C2.47713 3.60649 2.27315 3.81046 2.14533 4.06135C2 4.34656 2 4.71993 2 5.46667V11.8667C2 12.6134 2 12.9868 2.14533 13.272C2.27315 13.5229 2.47713 13.7269 2.72801 13.8547C3.01323 14 3.38659 14 4.13333 14Z"
                stroke="#282828"
                strokeLinecap="round"
            />
        </svg>
    );
};
export const User = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M10.5 4C10.5 4.66304 10.2366 5.29893 9.76777 5.76777C9.29893 6.23661 8.66304 6.5 8 6.5C7.33696 6.5 6.70108 6.23661 6.23223 5.76777C5.76339 5.29893 5.5 4.66304 5.5 4C5.5 3.33696 5.76339 2.70107 6.23223 2.23223C6.70108 1.76339 7.33696 1.5 8 1.5C8.66304 1.5 9.29893 1.76339 9.76777 2.23223C10.2366 2.70107 10.5 3.33696 10.5 4ZM3.00067 13.412C3.02209 12.1002 3.55823 10.8494 4.49345 9.92936C5.42868 9.00929 6.68806 8.49365 8 8.49365C9.31194 8.49365 10.5713 9.00929 11.5066 9.92936C12.4418 10.8494 12.9779 12.1002 12.9993 13.412C11.4309 14.1312 9.72543 14.5023 8 14.5C6.216 14.5 4.52267 14.1107 3.00067 13.412Z"
                stroke="black"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
export const USAFlag = ({ className = "" }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3791_48031)">
                <rect width="16" height="16" fill="url(#pattern0_3791_48031)" />
            </g>
            <defs>
                <pattern id="pattern0_3791_48031" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_3791_48031" transform="scale(0.0104167)" />
                </pattern>
                <clipPath id="clip0_3791_48031">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <image
                    id="image0_3791_48031"
                    width="96"
                    height="96"
                    href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAAAsTAAALEwEAmpwYAAACB0lEQVR4nO2YsUoDQRCG40ulvWIrS0EbsVREVLARQRF8AJ/AWrEKNqYQESw0ERRLEVFEsREWDslWQlzZgCEJGm3Omdx8Hwy3d9uE/9/ZmUmlAgAAAAAAAAAAAAAAAAAAJogxjmUT9TgKEVx1JAMDHAaQAT/BFVTVdwXt7N4OPbFF7i9vNOPSesNuDZhfPYuJhbXzb0Uoer959Robl6/2DJhZPI1PL63Ybn90BErP9J6+/8f+/sFDbIX3+EVap2+9Bvj8bSTjzxmwtX0de0nvvQIUuT8+fRRv7vLuXlqnb6YMmJo76RNocvakT4Ci9w+Pn7t7aT14BZXegFQA92r3HaHSM70PFsgi92v1x7iyedGJtDZngPbwCsTEgNxQBmibB4KFOUDzPBAsGKB5HghWMkDrPBCsGKB1HghWDNA6DwQrBmgNr6ClZA7IDcwB2vr/zFIGaOz/MwsGaO7/MwsGaO7/MysGaO3/MyttqNb+P7NigPYICsTEACcvKBng5EXlCnIlqgHSbZoveWBAjgHip9CTAfJCeK4geTGoAbm9+LUIS7dpoeSBAQ4DxE9hIAPkhQhcQfJiUAOcveCviFx5Gyr9A33JAwNyDBA/hZ4MkBfCcwXJi6GyBki3aaHkgQEOA8RPYSAD5IUIXEHyYlADnL0YWoQBAAAAAAAAAAAAAAAAAAAAKmXhE0VQ/rCIcNGYAAAAAElFTkSuQmCC"
                />
            </defs>
        </svg>
    );
};
export const MexicoFlag = ({ className = "" }) => {
    return (
        <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_3791_48036)">
                <rect width="16" height="16" fill="url(#pattern0_3791_48036)" />
            </g>
            <defs>
                <pattern id="pattern0_3791_48036" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlinkHref="#image0_3791_48036" transform="scale(0.0104167)" />
                </pattern>
                <clipPath id="clip0_3791_48036">
                    <rect width="16" height="16" fill="white" />
                </clipPath>
                <image
                    id="image0_3791_48036"
                    width="96"
                    height="96"
                    href="data:image/png;base64,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"
                />
            </defs>
        </svg>
    );
};
export const Coin = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
                d="M8 4V12M6 10.1213L6.586 10.5607C7.36667 11.1467 8.63267 11.1467 9.414 10.5607C10.1953 9.97467 10.1953 9.02533 9.414 8.43933C9.024 8.146 8.512 8 8 8C7.51667 8 7.03333 7.85333 6.66467 7.56067C5.92733 6.97467 5.92733 6.02533 6.66467 5.43933C7.402 4.85333 8.598 4.85333 9.33533 5.43933L9.612 5.65933M14 8C14 8.78793 13.8448 9.56815 13.5433 10.2961C13.2417 11.0241 12.7998 11.6855 12.2426 12.2426C11.6855 12.7998 11.0241 13.2417 10.2961 13.5433C9.56815 13.8448 8.78793 14 8 14C7.21207 14 6.43185 13.8448 5.7039 13.5433C4.97595 13.2417 4.31451 12.7998 3.75736 12.2426C3.20021 11.6855 2.75825 11.0241 2.45672 10.2961C2.15519 9.56815 2 8.78793 2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.5913 2 11.1174 2.63214 12.2426 3.75736C13.3679 4.88258 14 6.4087 14 8Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export const Clipunlink = ({ onClick = () => { }, className = "" }) => {
    return (
        <div
            onClick={onClick}
            className={`h-5 w-5 cursor-pointer ${className}`}
        >
            <svg width="100%" height="100%" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M30.7557 20.2545C32.0811 20.8884 33.2589 21.7931 34.213 22.9104C35.1671 24.0277 35.8762 25.3326 36.2946 26.741C36.7131 28.1493 36.8315 29.6298 36.6423 31.0867C36.453 32.5437 35.9603 33.9448 35.196 35.1995M12.404 28.7082L8.30669 32.8079C6.33724 34.777 5.23069 37.4479 5.23047 40.2329C5.23025 43.0179 6.33638 45.6889 8.30552 47.6584C10.2747 49.6278 12.9455 50.7344 15.7305 50.7346C18.5155 50.7348 21.1866 49.6287 23.156 47.6595L30.457 40.3585M43.5564 27.2569L47.656 23.1572C49.6255 21.188 50.732 18.5172 50.7322 15.7322C50.7325 12.9472 49.6263 10.2761 47.6572 8.30669C45.688 6.33724 43.0172 5.23069 40.2322 5.23047C37.4472 5.23025 34.7761 6.33638 32.8067 8.30552L22.3067 18.8055C21.7047 19.4122 21.189 20.0679 20.7644 20.7655M25.2047 35.7105C24.129 35.1958 23.1489 34.5014 22.3067 33.6572C21.1969 32.5504 20.3501 31.2083 19.8287 29.7302M48.9814 48.9849L35.1984 35.2019L20.762 20.7632M6.97902 6.97786L20.762 20.7679" stroke="#E4404B" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    )
}


export const ReloadArrow = ({ color = "#0F172A" }) => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M16.0228 9.34838H21.0154V9.3466M2.98413 19.6444V14.6517M2.98413 14.6517L7.97677 14.6517M2.98413 14.6517L6.16502 17.8347C7.15555 18.827 8.41261 19.58 9.86436 19.969C14.2654 21.1482 18.7892 18.5364 19.9685 14.1353M4.03073 9.86481C5.21 5.46371 9.73377 2.85191 14.1349 4.03118C15.5866 4.42017 16.8437 5.17309 17.8342 6.16547L21.0154 9.3466M21.0154 4.35577V9.3466"
                stroke={color}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round" />
        </svg>

    )
}

export const PencilSquare = ({ color = "#0F172A" }) => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.8617 4.48667L18.5492 2.79917C19.2814 2.06694 20.4686 2.06694 21.2008 2.79917C21.9331 3.53141 21.9331 4.71859 21.2008 5.45083L10.5822 16.0695C10.0535 16.5981 9.40144 16.9868 8.68489 17.2002L6 18L6.79978 15.3151C7.01323 14.5986 7.40185 13.9465 7.93052 13.4178L16.8617 4.48667ZM16.8617 4.48667L19.5 7.12499M18 14V18.75C18 19.9926 16.9926 21 15.75 21H5.25C4.00736 21 3 19.9926 3 18.75V8.24999C3 7.00735 4.00736 5.99999 5.25 5.99999H10" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}


export const CloseOutlined = ({ color = "#0F172A" }) => {
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6M6 6L18 18" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export const Trash = ({ color = "#0F172A" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 30"
            width="100%"
            height="100%"
            fill={color}
        >
            <path
                d="M 13 3 A 1.0001 1.0001 0 0 0 11.986328 4 L 6 4 A 1.0001 1.0001 0 1 0 6 6 L 24 6 A 1.0001 1.0001 0 1 0 24 4 L 18.013672 4 A 1.0001 1.0001 0 0 0 17 3 L 13 3 z M 6 8 L 6 24 C 6 25.105 6.895 26 8 26 L 22 26 C 23.105 26 24 25.105 24 24 L 24 8 L 6 8 z" />
        </svg>
    )
}